import { Api } from "../api/api";
import { Injectable } from "@angular/core";

import { Observable } from "rxjs/Observable";

@Injectable()
export class ChanceTimeProvider {
  private url: string = "chance_times";

  constructor(public api: Api) {}

  //新規登録チャンスタイム、有料会員復活チャンスタイムを作成
  post(chanceTimeId: number): Observable<any> {
    return this.api.post(this.url, { id: chanceTimeId });
  }

  createChurnChanceTime(): Observable<any> {
    return this.api.post(this.url + "/create_after_churn_chance_time", {});
  }
}



// WEBPACK FOOTER //
// ./src/providers/chance-time/chance-time.ts